import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '../apps/index/NotFound.vue'
Vue.use(Router)
export function getRouter(route) {
  let { routes } = route
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes.concat([
      {
        path: '/404',
        name: '404',
        component: NotFound
      },
      {
        path: '*',
        redirect: '/404'
      }
    ])
  })
}
